import { SideNavSectionConfig, SideNavStyle } from '../types';
import { NormalSideNavSection } from './NormalSideNavSection';
import { NestedSideNavSection } from './NestedSideNavSection';

const INNER_SECTION_COMPONENTS_BY_STYLE: Record<
  SideNavStyle,
  React.FC<React.PropsWithChildren<SideNavSectionConfig>>
> = {
  [SideNavStyle.normal]: NormalSideNavSection,
  [SideNavStyle.nested]: NestedSideNavSection,
};

type SideNavSectionProps = SideNavSectionConfig & {
  style: SideNavStyle;
};

export const SideNavSection = ({ style, ...innerSectionProps }: SideNavSectionProps) => {
  const Section = INNER_SECTION_COMPONENTS_BY_STYLE[style];
  return <Section {...innerSectionProps} />;
};
